define(function (require) {

	//models
	const IPSModel = require('civicsBase/ipsModel');
	const map_extent_model = require('civicsModels/location/map_extent_model');

	//collections
	const IPSCollection = require('civicsBase/ipsModelCollection');
	//const nearest_address_collection = require('civicsCollections/location/nearest_address_collection');
	//const nearest_parcel_collection = require('civicsCollections/location/nearest_parcel_collection');
	const nearest_site_collection = require('civicsCollections/location/nearest_site_collection');

	const location_collection = require('civicsCollections/address_collection');
	const asset_model = require('civicsModels/asset_model');

	//utilities
	const view_manager = require('civicsUtils/view_manager');
	const Big = require('civicsUtils/libraries/big');
	const siteBuilder = require('civicsUtils/site_builder');

	const CN = require('civicsUtils/constants');
	//site types
	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';
	const coords = 'coords'
	//methods
	const autocomplete = 'autocomplete';
	const mapclick = 'mapclick';
	const geolocation = 'geolocation';

	return {
		canBeAdditionalSite:function(site){
			let ret = false;
			let type = site.get ? site.get('_siteType') : site._siteType;
			if(type){
				if(type!='coords' && (this.config.additionalSiteType & CN[type.toUpperCase()])){
					ret = true;
				}
			} else {
				console.log('No _siteType for additional site',site);
			}
			//if we can't add additional sites, then this simply can't be an additional site.
			return !this.additionalSitesHiddenByConstraints && ret;
		},
		canBePrimarySite:function(site){
			let ret = false;
			if(site){
				let type = site.get ? site.get('_siteType') : site._siteType;
				
				if(type){
					if((this.config.primarySiteType & CN[type.toUpperCase()]) || type.toLowerCase() == 'coords'){
						ret = true;
					}
				}else {
					console.log('No _siteType for primary site',site);
				}
			}
			//if we can't add primary sites, then this simply can't be a primary site.
			return !this.primarySiteHiddenByConstraints && ret;
		},
		//return which site Types(asset, address, parcel) are allowed for the current type of site (primary, associated). YEah, I know site type and type of site is confusing.
		currentSiteTypes:function(){
			return this.primarySiteSelected() ? this.config.additionalSiteType : this.config.primarySiteType;
		},
		currentSiteTypeArray:function(){
			let currentBit = this.currentSiteTypes();
			let types = [address,parcel,asset,property];//string representations of the site types
			let currentTypes = [];
			types.forEach(type => {
				if(currentBit & CN[type.toUpperCase()]){
					currentTypes.push(type);
				}
			});
			if(!this.primarySiteSelected()){//we allow coords for primary site
				currentTypes.push(coords);
			}
			return currentTypes;
		},
		canAddSite:function(){
			let ret = true;
			if(this.primarySiteSelected() && this.additionalSitesHiddenByConstraints){
				ret = false;
			}
			return ret;
		},
		showCannotAddSiteModal:function(res, extent,source=mapclick){//this cna only be hit when we have a primary site and additional sites are not allowed. we tailor the message as such.
			let primarySite = this.selectedSitesCollection.findWhere({primarySite:true});
			let text = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.CAN_ONLY_SELECT_ONE_SITE',{primarySite:primarySite.get('_displayText').trim()});

			//we don't have an ok callback for when the additional site can't be the primary. we just close the dialog.
			//when the primary site can't be the additional, the ok call back will remove the primary and set the new primary
			let okCallback = null;
			if(source == mapclick){
				okCallback = function(){
					this.selectedSitesCollection.remove(primarySite);
					//proceed with their map click
					this.mapClicked(res,extent);
				}.bind(this);
			} else if(source == autocomplete){
				okCallback = function(){
					this.selectedSitesCollection.remove(primarySite);
					//proceed with their autocomplete
					this.getIPSDataForLocation(res);
				}.bind(this);
			}
			let title = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SITE_SELECTION_ISSUE_TITLE');
			let okText = i18n.t('CIVICS.COMMON.YES');
			let cancelText = i18n.t('CIVICS.COMMON.NO');
			this.openModal(title,text, okText, okCallback, cancelText)
		},
		checkForSpatial: function (location) {
			var ret = false;
			if (location && location.Spatial && location.Spatial.xCoordinate && location.Spatial.yCoordinate) {
				ret = true;
			}
			return ret;
		},
		
		getNearbySites: function (coordinates, extentSize) {
			var retProm = $.Deferred();
			//clear any previous click's nearby sites at the start of a new click. This replaces the
			//clearing that recreating the collection in displayLocationPicker() used to provide, and
			//works regardless of whether the fetch below resolves synchronously or asynchronously.
			//Reset SILENTLY: the collection is now persistent, so a non-silent reset would fire
			//reset/update events on the previously-shown picker (and its CompositeView child lists)
			//that are still bound to it. Repopulation is driven by the non-silent pin add in
			//addCoordinatesInCollectionAndPlacePin below, and displayLocationPicker() rebuilds the picker.
			this.nearbySitesCollection.reset([], { silent: true });
			this.showLoadingOverlay(true);
			let sitesMaxCount = this.config.cdrNewLocation.nearbySitesMaxCount;
			let getCenterPoint = this.config.cdrNewLocation.additionalSitesOnMap ? false : true;
			let nearestSites = new nearest_site_collection();
			//let removeSite = false;
			nearestSites.selectedSitesCollection = this.selectedSitesCollection;
			let layerList = this.activeMapLayers;
			let currentSiteTypes = this.currentSiteTypeArray();
			let currentLayers = layerList.filter((site)=>{
				let ret = false;
				currentSiteTypes.forEach((type) => {
					if(site.siteType == type){
						ret = true;
					} 
				});
				return ret;
			})

			let index = 1;

			$.when(nearestSites.fetchClosestSites(currentLayers, coordinates, extentSize, sitesMaxCount, getCenterPoint)).done((sites) => {

				// sites.forEach((site) =>{
				// 	site._siteIndex = index++;
				// });
				this.nearbySitesCollection.add(sites,{silent:true});
				this.addCoordinatesInCollectionAndPlacePin(coordinates, this.nearbySitesCollection);
				this.updateNearbySitesIndexesAndIcons();
				this.views.locationPickerView.clickedPoint = coordinates;

			})
			.always(() => {
				this.showLoadingOverlay(false);
				retProm.resolve();
			});
			return retProm;
		},

		IPSLocationFound: function (location) {
			//log to IPS if there's no spatial data.
			if (!this.checkForSpatial(location)) {
				var error = 'No spatial data for site ';
				error += location.id;
				view_manager.logError(error)
			} else {
				this.centerMapOnCoordinatesAndPlacePin({
					//if the response has a record, it will always have a spatial with x/y. other wise it wouldn't have been found.
					x: location.Spatial.xCoordinate,
					y: location.Spatial.yCoordinate
				});
			}
		},

		
		
		//if site isn't null, then we got a primary site on load from cloning or continuing a saved site.
		processProvidedSites: async function(sites, extentSize, isClone){
			if(sites == null){
				return new Backbone.Collection();
			}
			if(!(sites instanceof Backbone.Collection)){
				//if we receive a single site, as a model or object, convert it to a collection.
				//if we receive an array, do the same.
				sites = new Backbone.Collection(sites);
			}
			const models = sites.models;
			for(let i = 0; i < models.length; i++){
				await this.processProvidedSite(models[i]);
			}
			return sites;
		},
		processProvidedSite: async function(site){
			//_siteType means we have the data we need, as we add this in the location collection parse functions.
			if(site.get('_siteType')!=null){
				return;
			}else{
				//siteInfo exists when there is associated properties for saved instrument
				if(site.get('siteInfo') != null){
					let siteInfo = site.get('siteInfo');
					site.set(siteInfo,{silent:true});
					//site.set({_siteType: site.get('siteInfo')._siteType},{silent:true});
					return;
				}
			}
			let type = site.get('asset') && site.get('asset').id > 1 ? asset : site.get('type');
			type = type ? type.trim().toLowerCase() : '';
			if(type!=''){
				site.set({_siteType: type},{silent:true});
			} 
			if(type == '' || type == coords){//if type is empty, it's likely coordinates.
				let spatial = {};
				if(site.get('lon')){
					spatial.xCoordinate = site.get('lon');
					spatial.yCoordinate = site.get('lat');
				} 
				if(spatial.xCoordinate && spatial.yCoordinate){
					//realistically coordinates can only be primary, but just in case...
					let displayText = site.get('displayText') ? site.get('displayText') : `x: ${spatial.xCoordinate}, y: ${spatial.yCoordinate}`;
					site.set({
						_siteType:'coords',
						Spatial:spatial,
						displayText: site.get('primarySite')===true ? i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.PINNED_LOCATION') : displayText
					}, 
					{silent:true});
				}
			}
			//check the address/asset type then build location lines
			if(site.get('displayText') == null){
				let displayLocationText ="";
				displayLocationText = siteBuilder.buildLocationLine1(site.toJSON());

				if(type == address && site.get('locationLine2')){
					let displayLine2 = siteBuilder.buildLocationLine2(site.toJSON());
					displayLocationText = displayLocationText + " " + displayLine2;
				}
				site.set({
					displayText: displayLocationText
				},{silent:true});
			}
			site.set({
				_displayText:site.get('_siteType') == parcel ? site.get('parcelId') : site.get('displayText')
			},
			{silent:true});

			//coords sites carry their location in Spatial (lon/lat) and have no IPS key, so there is
			//nothing to look up. fetchIPSLocationData returns null for them; calling .done() on that
			//would throw and reject the whole processProvidedSites chain, leaving the primary site
			//(and selectedSitesCollection) unpopulated.
			if(site.get('_siteType') != coords && (site.get('id')== null || site.get('id') == 1)){
				//if we have no site ID, we need more info from IPS
				let locationDataPromise = this.fetchIPSLocationData(site.toJSON());
				if(locationDataPromise){
					this.showLoadingOverlay(true);
					locationDataPromise.done((response)=>{
						site.set(response.data);
					}).fail(response=>{
						
					}).always(()=>{
						this.showLoadingOverlay(false);
					});
				}
			}
		},
		//Typically, when we get here we have a valid IPS key in the location parameter. However, in the case of cloning, 
		//we may have a valid but EXPIRED or INNEFFECTIVE IPS key. This will result in a 404 error when fetching
		//when cloning, we want to hide that error. For other cases, we should display it as it is likely a valid error.
		//So, we pass in the this.config.isClone flag as the failQuietly parameter
		getIPSDataForLocation: function(location, failQuietly) {
			this.showLoadingOverlay(true);
			
			this.fetchIPSLocationData(location).done((response) => {
				response.data._method = location._method;
				
				let sitesExist = this.selectedSitesCollection.where({ 
					id: response.data.id, 
					_siteType: response.data._siteType 
				});
				
				if (sitesExist && sitesExist.length > 0) {
					var error = {
						combinedSite: i18n.t('CIVICS.COMMON.DUPLICATE_SITE_ERROR')
					};
					view_manager.errorToWindow({
						validationError: error
					}, this);
				} else {
					this.selectedSitesCollection.add(new Backbone.Model(response.data));
				}
				this.showLoadingOverlay(false);
			}).fail((response, status, xhrResponse) => {
				if (!failQuietly) {
					view_manager.errorToWindow(response);
				}
				this.showLoadingOverlay(false);
			});
		},

		fetchIPSLocationData: function(location) {
			var locationCollection = new location_collection();
			
			let id, siteType;
			
			if ((id = location.AddressKey || location.address) && id > 1) {
				siteType = address;
			} else if ((id = location.ParcelKey || location.parcel) && id > 1) {
				siteType = parcel;
			} else if ((id = location.AssetKey || location.asset) && id > 1) {
				//note that we don't currently allow selection of asset in CPQ, so .asset should never be set. 
				//it's also a guess - because we don't support it, we don't know what attribute will actually be set.
				siteType = asset;
			} else {
				return null;
			}
			
			locationCollection.urlAttributes = {
				passThroughString: 'id=' + id
			};
			locationCollection.siteType = siteType;
			
			return locationCollection.fetch();
		},
		
		/* SELECTED SITE COLLECTION FUNCTIONS */
		addingSiteToSelectedSitesCollection:function(newSiteModel){
			newSiteModel.set('primarySite',
				!this.primarySiteSelected() && this.canBePrimarySite(newSiteModel));

			//add zoom_to_pin to zoom on this item. The maps will remove it once zoomed. 
			newSiteModel.set('_ZOOM_TO_PIN_', true);
			this.updateSelectedSiteIndexesAndIcons(false);
			this.updatePrimaryVsAdditionalSiteMessaging();
			this.resetErrorMessages();

		},
		primarySiteSelected:function(){
			//findWhere will return undefined if no matching models exist. If the primary site is hidden, we always return true, so we will only ever add additional sites.
			return this.primarySiteHiddenByConstraints || this.selectedSitesCollection.findWhere({primarySite:true}) !=undefined;
		},
		additionalSiteSelected:function(){
			return this.selectedSitesCollection.findWhere({primarySite:false}) !=undefined;
		},
		setPrimarySite:function(favoriteModel){
			let primarySite = this.selectedSitesCollection.findWhere({primarySite:true})

			if(this.canBePrimarySite(favoriteModel) && (primarySite == undefined || this.canBeAdditionalSite(primarySite))){
			//set existing primarySite to False, and prevent render by using silent
			
				if(primarySite!=undefined){
					primarySite.set({primarySite:false},{silent:true});
				}
				//again, prevent render
				favoriteModel.set({primarySite:true},{silent:true});
				//reindex the collection for display purposes
				this.updateSelectedSiteIndexesAndIcons(true);
				//manually trigger the reset to avoid multiple renders. Note that we could do this by actually calling reset and passing in the models, 
				//however there would be additional processing done as the collection will empty itself and readd each individual model.
				this.selectedSitesCollection.trigger('update');
				this.showToastMessage(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SITES_UPDATED_SUCCESSFULLY'));
			}
			else {
				//let text = `Setting (${favoriteModel.get('_displayText').trim()}) as the primary site will remove  (${primarySite.get('_displayText').trim()}) from the instrument. Do you want to continue?`;
				let text = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SETTING_SITE_REMOVES_CURRENT',{selectedSite:favoriteModel.get('_displayText').trim(), primarySite:primarySite.get('_displayText').trim()});
				let cannotBePrimary = false;
				if(!this.canBePrimarySite(favoriteModel)){
					text = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SITE_CANNOT_BE_PRIMARY');
					cannotBePrimary = true;
				}
				//we don't have an ok callback for when the additional site can't be the primary. we just close the dialog.
				//when the primary site can't be the additional, the ok call back will remove the primary and set the new primary
				let okCallback = cannotBePrimary ? null : function(){
					this.selectedSitesCollection.remove(primarySite);
					this.setPrimarySite(favoriteModel);
				}.bind(this);
				let title = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SITE_SELECTION_ISSUE_TITLE');
				let okText = cannotBePrimary ? "" : i18n.t('CIVICS.COMMON.YES');
				let cancelText = i18n.t('CIVICS.COMMON.NO');
				this.openModal(title,text, okText, okCallback, cancelText)
			}
			//updating the messaging when setting primary site
			this.updatePrimaryVsAdditionalSiteMessaging();

		},
		setupSelectedSites:function(){
			let processSitesPromise = $.Deferred();
			let retProm = $.Deferred();
			if(this.options.providedSites){
				//translate the nativ epromise back into our standard $.Deferred()
				this.processProvidedSites(this.options.providedSites).then((sites)=>{
					processSitesPromise.resolve(sites);
				}).catch((error)=>{
					processSitesPromise.reject(error);
				});
			} else {
				processSitesPromise.resolve(new Backbone.Collection());
			}
			processSitesPromise.done((sites)=>{
				//Populate the persistent collection created in initialize rather than reassigning it,
				//so any reference taken before setup resolves (e.g. an early map click) stays valid.
				//Reset silently: the 'add' handler below is bound after this, and child views bind
				//their listeners once setupSelectedSitesPromise resolves.
				//
				//processProvidedSites can hand back a collection owned by the caller (the clone/resume
				//path builds one in the portlet from the loaded instrument's sites). Backbone's
				//_prepareModel will not take ownership of a model that already has one
				//('if (!attrs.collection) attrs.collection = this'), so release the source collection
				//first. Otherwise every seeded site keeps model.collection pointing at that throw-away
				//collection, and the selected site remove/favorite handlers - which reach the
				//collection through model.collection - act on the wrong one: 'setPrimarySite' fires
				//where nothing is listening, and remove() drops the model from the throw-away
				//collection (which also deletes model.collection, breaking every later click).
				//Keep the same model instances rather than re-creating from toJSON(): processProvidedSite
				//starts un-awaited IPS lookups that later 'set' onto these exact models, and copies
				//would leave those results landing on orphaned models.
				let providedModels = sites.models.slice();
				sites.reset([], {silent:true});
				this.selectedSitesCollection.reset(providedModels, {silent:true});
			
				this.selectedSitesCollection.primarySiteHiddenByConstraints = this.primarySiteHiddenByConstraints;
				this.selectedSitesCollection.additionalSitesHiddenByConstraints = this.additionalSitesHiddenByConstraints;
				this.updateSelectedSiteIndexesAndIcons();
				this.selectedSitesCollection.on('setPrimarySite',this.setPrimarySite.bind(this));
				this.selectedSitesCollection.on('add',(site)=>{
					this.addingSiteToSelectedSitesCollection(site);
					this.showToastMessage(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SITE_ADDED_SUCCESSFULLY'));
				});			//we do the same things to the overall collection on remove that we do on add, minus the individual site element. So we call the same function.
				this.selectedSitesCollection.on('remove',(site)=>{
					this.addingSiteToSelectedSitesCollection(site);
					this.showToastMessage(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SITE_REMOVED_SUCCESSFULLY'));
				});
			
				//TO DO: move this function to the map logic
				this.selectedSitesCollection.on( 'setPrimarySite update', function(){
					//we dont necessarily need to clear the markers for every update, we clear it when map was clicked and we are attempting to show the selected sites markers.
					if(this.mapClickedMethod){
						this.trigger('collection:cleared');
						this.mapClickedMethod = null;
					}
					this.trigger('collection:updated', {
						collection: this.selectedSitesCollection
					});
					this.removeMapProperty(this.selectedSitesCollection);
				},this);

				this.selectedSitesCollection.on('showAllSitesInMap', this.showAllSelectedSitesOnMap.bind(this));
				retProm.resolve();
			}).fail(response=>{
				retProm.reject();
			});
			return retProm;
		},
		removeMapProperty: function(collection){
			collection.forEach((ss) =>{
				ss.unset('_ZOOM_TO_PIN_');
			})
		}
	}
});